module.exports = __webpack_public_path__ + "static/media/43-4.a40680c6.mp3";